/**
 * Slug simple para usar como parte del id (evita colisiones entre extras con mismo id o sin id).
 */
function slugify(str) {
  if (str == null || str === '') return 'x';
  return String(str)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

/**
 * Id estable para extras en el carrito.
 * Mismo extra del mismo combo/producto se agrupa (suma cantidad).
 * Incluye el nombre del extra en la clave para que extras distintos (Double meat, Extra Avocado)
 * no se fusionen aunque la API devuelva el mismo extra.id.
 */
export function getExtraCartId(parentType, parentId, extraId, extraName = '') {
  const slug = slugify(extraName);
  const key = extraId != null && extraId !== '' ? `${extraId}-${slug}` : slug;
  return `extra-${parentType}-${parentId}-${key}`;
}
